module.exports = __webpack_public_path__ + "media/images/logo_mizuho-re-e1a3d396f085c187e9c531cfb4dda82d.png";